import BlogLinkCard from "./BlogLinkCard";
import MainaIcon from "./MainaIcon";
import Alert from "./Alert";
import { useTranslation } from "react-i18next";

function Section01({ config }) {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const getImagePath = (imageName) => {
    return `${process.env.PUBLIC_URL}/images/${currentLanguage}/${imageName}`;
  }
  return (
    <div>
      <div className="bg-white rounded max-w-3xl px-4 pt-6 lg:pt-10 pb-12 sm:px-6 lg:px-8 mx-auto">
        <div className="max-w-2xl">
          <div className="space-y-5 md:space-y-8">
            {config.show_section_title && (
              <div className="space-y-8 mb-12">
                <div className="max-w-2xl mx-auto mb-10 lg:mb-14">
                  <h2 className="flex items-center text-2xl font-bold md:text-4xl md:leading-tight text-modern-primary">
                    <div className="mr-4">
                      <MainaIcon sizeNum="3.5" />
                    </div>
                    {t('マイナポータルで確認')}
                  </h2>
                </div>
              </div>
            )}

            <p>{t('マイナ保険証が利用できる方は、マイナポータルでご自分の記号・番号・枝番やご加入の組合の保険者番号を確認できます。')}</p>

            <Alert title="事前にマイナンバーカードの保険証利用の申請が必要です。">
              {t('ご自分のマイナンバーカードが申請済みかどうかはマイナポータルで確認できます。申請自体もマイナポータルから行うことができます。')}
              <br />
              {t('以下の手順に従ってマイナポータルにログインしてご確認ください。')}
            </Alert>

            <div className="space-y-8 scroll-mt-24 bg-white border rounded-lg p-8 mt-10">
              <h3 className="text-2xl font-semibold pb-6 border-b border-modern-accent text-modern-textDark">
                {t('手順１：マイナポータルにログイン')}
              </h3>

              <p className="text-lg text-gray-800">
                <a href="https://myna.go.jp/" target="myna">
                  {t('マイナポータル')}
                </a>
                {t('へのログイン方法はデジタル庁のホームページでくわしい動画解説が公開されていますのでご参照ください。')}
              </p>
              <BlogLinkCard
                title="マイナポータルへのログイン方法"
                description="利用ガイド｜マイナポータルアプリ｜デジタル庁"
                imageUrl="https://services.digital.go.jp/uploads/og_images/ogp.png"
                link="https://services.digital.go.jp/mynaportal-app/help/"
                target="digital_go_jp"
              />
            </div>

            <div className="space-y-8 scroll-mt-24 bg-white border rounded-lg p-8 mt-10">
              <h3 className="text-2xl font-semibold pb-6 border-b border-modern-accent text-modern-textDark">
                {t('手順２：メニューから「健康保険証」を選択')}
              </h3>

              <p className="text-lg text-gray-800">
                {t('ログイン後、ホーム画面の「証明書」＞「健康保険証」を選択します。')}
              </p>
              <figure className="flex flex-col justify-center items-center">
                <img
                  className="rounded-xl shadow-md"
                  src={getImagePath('mynaportal-home01.png')}
                  alt={t('ホーム画面の「証明書」＞「健康保険証」を選択します。')}
                  loading="lazy"
                />
                <figcaption className="mt-3 text-sm text-center text-gray-500">
                  {t('iPhoneの場合の画面です。ご利用のデバイスによって一部異なる場合があります。')}
                </figcaption>
              </figure>
            </div>

            <div className="space-y-8 scroll-mt-24 bg-white border rounded-lg p-8 mt-10">
              <h3 className="text-2xl font-semibold pb-6 border-b border-modern-accent text-modern-textDark">
                {t('手順３：健康保険証の資格情報を確認')}
              </h3>

              <p className="text-lg text-gray-800">
                {t('健康保険証の資格情報が表示されるので画面をスクロールして必要な情報を確認してください。')}
              </p>
              <figure className="flex flex-col justify-center items-center">
                <img
                  className="rounded-xl shadow-md"
                  src={getImagePath('mynaportal-hokensho01.png')}
                  alt={t('保険証の記号番号、保険者番号を確認できます')}
                  loading="lazy"
                />
                <figcaption className="mt-3 text-sm text-center text-gray-500">
                  {t('iPhoneの場合の画面です。ご利用のデバイスによって一部異なる場合があります。')}
                </figcaption>
              </figure>
            </div>

            <div className="space-y-8 scroll-mt-24 bg-white border rounded-lg p-8 mt-10">
              <h3 className="text-2xl font-semibold pb-6 border-b border-modern-accent text-modern-textDark">
                {t('（参考）過去の資格情報の確認方法')}
              </h3>
              <p className="text-lg text-gray-800">
                {t('マイナポータルでは過去に加入していた健康保険の資格情報も確認できます。')}<br />
                {t('マイナポータルにログイン後、メニューから以下の順に選択します。')}<br /><br />
                <ol className="list-decimal list-inside">
                    <li>{t('「その他のわたしの情報」')}</li>
                    <li>{t('「健康・医療」')}</li>
                    <li>{t('「その他の項目」')}</li>
                    <li>{t('「医療保険」')}</li>
                </ol><br />
                {t('「取得する情報の選択」画面で取得依頼対象日を指定して「確認する」をクリックし、内容を確認のうえ「取得する」を選択してください。')}<br />
                {t('取得完了後は「回答結果一覧へ」から結果を確認できます。')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section01;
